import nodeMarquee from 'node-marquee';

const Marquee = () => {
  const els = document.querySelectorAll('.marquee');

  if (els.length) {
    els.forEach((el) => {
      const marquee = nodeMarquee({
        parent: el,
        speed: parseFloat(el?.dataset?.speed ?? 0.5),
        prependWhitespace: false,
        minQuantity: 3,
      });
    });
  }
};

export default Marquee;
